// import  axios  from 'axios';
import {Axios} from '../plugins/axios.js';


const state = {
}

const getters = {

}

const mutations =  {

}

const actions = {
  entryAndEdit ({ commit, state }, payload) {
     const data             = payload.data;
     const formData         = new FormData();

     for (let key in data) {
       formData.append(key,data[key])
     }

     // request send new data //
     if (typeof(data.id) == 'undefined') {
         return new Axios()
         .post(`biav/v1/admin/cup_item/store`,formData)
         .then(response => {
           return response;
         })
         .catch(()=>{
           return 'error';
         })
     }
     else {
       // edit data //
       return new Axios()
       .post(`biav/v1/admin/cup_item/update`,formData)
       .then(response => {
         return response;
       })
       .catch(()=>{
         return 'error';
       })
     }

  },

  getAllCups ({ commit, state }, payload) {
    return new Axios()
    .get(`biav/v1/admin/cup`)
    .then(response => {
      return response;
    })
    .catch(()=>{
      return 'error';
    })
  },









}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
